import styled from 'styled-components'

export const Wrapper = styled.div`
    background: ${(props) => props.theme.color.g100};
    padding: 50px 20px;

    @media ${(props) => props.theme.query.min.tablet} {
        padding: 150px 0;
    }
`

export const Title = styled.h2`
    ${(props) => props.theme.typo.displayM}
    color: ${(props) => props.theme.color.g500};
    ${(props) => props.theme.fontWeight.bold};

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.displayL}
    }
`

export const CategoryWrapper = styled.div`
    display: flex;
    gap: 30px;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 50px;
`
